import { AppPage } from '@juvare/common-web-ui/AppPage';
import { AppPageHeader1 } from '@juvare/common-web-ui/AppPageHeader1';
import { Link, Typography } from '@mui/material';
import { marked } from 'marked';
import React from 'react';
import { Example, ExampleProps } from './Example';
import { Markdown } from './Markdown';

export interface DocPageProps {
    name: string;
    doc: string;
    examples: ExampleProps[];
}

export const DocPage: React.FC<DocPageProps> = (props) => {
    const html = marked(props.doc);
    return (
        <AppPage header={<AppPageHeader1 title={props.name} />} contentPadding={2} contentScrollable={true}>
            <Typography style={{ float: 'right' }}>
                <Link href={process.env.PROJECT_REPOSITORY + '/src/' + props.name + '/index.tsx'} target='_blank'>
                    Source Code
                </Link>
            </Typography>
            <Markdown html={html} />
            {props.examples.map((example) => {
                return <Example key={example.name} {...example} component={props.name} />;
            })}
        </AppPage>
    );
};
